import { render, staticRenderFns } from "./PicBusiness.vue?vue&type=template&id=732cddf4&scoped=true"
import script from "./PicBusiness.vue?vue&type=script&lang=js"
export * from "./PicBusiness.vue?vue&type=script&lang=js"
import style0 from "./PicBusiness.vue?vue&type=style&index=0&id=732cddf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732cddf4",
  null
  
)

export default component.exports